module.exports = __webpack_public_path__ + "img/rc-back.96755d38.png";